module.exports = __webpack_public_path__ + "img/51626502_L.20e5ae30.png";